module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isNew) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "dark": "",
      "color": "green"
    },
    on: {
      "click": _vm.saveShare
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": _vm.updateShare
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.deleteDialogVisible = true
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [(_vm.shareUrl && !_vm.isNew) ? _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Share URL",
      "disabled": ""
    },
    model: {
      value: (_vm.shareUrl),
      callback: function($$v) {
        _vm.shareUrl = $$v
      },
      expression: "shareUrl"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.copyShareUrl
    }
  }, [_c('v-icon', [_vm._v("content_copy")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Collection Name"
    },
    model: {
      value: (_vm.shareAlbum.name),
      callback: function($$v) {
        _vm.$set(_vm.shareAlbum, "name", $$v)
      },
      expression: "shareAlbum.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "description",
      "label": "Description"
    },
    model: {
      value: (_vm.shareAlbum.description),
      callback: function($$v) {
        _vm.$set(_vm.shareAlbum, "description", $$v)
      },
      expression: "shareAlbum.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-autocomplete', {
    attrs: {
      "label": "Shared Categories",
      "items": _vm.getCategories,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "chips": ""
    },
    model: {
      value: (_vm.shareAlbum.categoryIDs),
      callback: function($$v) {
        _vm.$set(_vm.shareAlbum, "categoryIDs", $$v)
      },
      expression: "shareAlbum.categoryIDs"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "id": "tags"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Shared Tags",
      "items": _vm.getTags,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "chips": ""
    },
    model: {
      value: (_vm.shareAlbum.tags),
      callback: function($$v) {
        _vm.$set(_vm.shareAlbum, "tags", $$v)
      },
      expression: "shareAlbum.tags"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "combine-mode-hint text-body-2 mb-2"
  }, [_vm._v(_vm._s(_vm.combineModeHint))]), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "dense": "",
      "color": "primary"
    },
    model: {
      value: (_vm.shareAlbum.combineMode),
      callback: function($$v) {
        _vm.$set(_vm.shareAlbum, "combineMode", $$v)
      },
      expression: "shareAlbum.combineMode"
    }
  }, [_c('v-btn', {
    attrs: {
      "value": "or",
      "small": ""
    }
  }, [_vm._v("Any (OR)")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "value": "and",
      "small": ""
    }
  }, [_vm._v("All (AND)")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.deleteDialogVisible),
      callback: function($$v) {
        _vm.deleteDialogVisible = $$v
      },
      expression: "deleteDialogVisible"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this share?  This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteShare.apply(null, arguments)
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d21aee6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareEdit.vue
// module id = 449
// module chunks = 1